<div
    class="container-fluid cmps-widget-pie-bar"
    *ngIf="data != null"
>
    <div aria-hidden="true">
        <div class="row">
            <div class="col-12 p-0">
                <div class="header">{{ data.piePillar.title }}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-5 col-sm-12 pie-chart">
                <div
                    class="chart"
                    [ngClass]="{ pointer: hasPieBarClick }"
                    (click)="onPieBarClick($event)"
                >
                    <ng-chart-arc
                        [options]="pieOptions"
                        [data]="data.d3.data.pie"
                        #arc="ngChartArc"
                    ></ng-chart-arc>
                </div>
                <div [ngClass]="data.piePillar.trendClass">
                    <cmps-icon
                        [style.fill]="
                            data.piePillar.trendClass
                                .split(' ')[0]
                                .toLowerCase()
                        "
                        [svgIcon]="
                            data.piePillar.trendClass
                                .split(' ')[1]
                                .toLowerCase()
                        "
                        *ngIf="
                            data.piePillar.trendClass?.split(' ')?.length > 1
                        "
                    ></cmps-icon>
                </div>
            </div>
            <div
                class="col-5 col-sm-12 pr-2 pl-2"
                [ngClass]="{ pointer: hasPieBarClick }"
                (click)="onPieBarClick($event)"
                *ngIf="data.d3.data.bar"
            >
                <ng-chart-vertical
                    [options]="barOptions"
                    [data]="data.d3.data.bar"
                    #vertical="ngChartVertical"
                ></ng-chart-vertical>
            </div>
        </div>
    </div>
    <div class="row">
        <span
            class="sr-only"
            role="heading"
            aria-level="3"
            >{{ data.piePillar.title }}</span
        >
        <cmps-screen-reader-table
            [options]="srTableOptions"
            [data]="srTableData"
        ></cmps-screen-reader-table>
        <button
            type="button"
            class="sr-only"
            tabindex="0"
            aria-haspopup="true"
            (click)="onPieBarClick($event)"
            *ngIf="hasPieBarClick"
        >
            Show details
        </button>
    </div>
</div>
